import { makeAutoObservable } from 'mobx';
import { joinValuesToString } from 'ziphy-web-shared/basic/helpers';
import { joinArrayWithObjectToString } from '@modules/_LEGACY_/fhir/fhir.utils';
import { getServiceRequestSubType } from '../extractor.helpers';
import { IExtractorServiceRequestSubType } from '../extractor.types';
import { prepareMeta } from '../fhir.converters';
import { getCodingObjects, getExtensionObjects, getIdentifierObjects } from '../fhir.helpers';
import ExtractorBase from './Base';
class ExtractorServiceRequest {
    constructor(resource) {
        this.base = new ExtractorBase(this);
        this.base.SET(resource);
        makeAutoObservable(this);
    }
    get resource() {
        return this.base.resource;
    }
    get subType() {
        return getServiceRequestSubType(this);
    }
    get isReferral() {
        return this.subType === IExtractorServiceRequestSubType.REFERRAL || this.performerType;
    }
    get isOrder() {
        return this.subType === IExtractorServiceRequestSubType.ORDER || this.orderDetails;
    }
    /*
     * RESOURCE - Minimally prepared resource data, prepareConverters, valueObjects, etc.
     */
    get extensions() {
        return getExtensionObjects(this.resource.extension);
    }
    get identifiers() {
        return getIdentifierObjects(this.resource.identifier);
    }
    get categories() {
        return getCodingObjects(this.resource.category);
    }
    get codes() {
        return getCodingObjects(this.resource.code);
    }
    get performerTypes() {
        return getCodingObjects(this.resource.performerType);
    }
    get orderDetails() {
        return getCodingObjects(this.resource.orderDetail);
    }
    get reasonCodes() {
        return getCodingObjects(this.resource.reasonCode);
    }
    // other in the FHIR - Group | Device
    get subject() {
        return this.base.getChildExtractor(this.resource.subject);
    }
    // other in the FHIR - Device
    get requester() {
        return this.base.getChildExtractor(this.resource.requester);
    }
    get meta() {
        return prepareMeta(this.resource.meta);
    }
    /*
     * READ - PREPARED Values
     */
    get zid() {
        return this.identifiers.first({ config: 'zid' });
    }
    get codeObj() {
        if (this.isReferral) {
            return this.performerType;
        }
        return this.codes.first();
    }
    get category() {
        return this.categories.first();
    }
    get performerType() {
        return this.performerTypes.first();
    }
    get notes() {
        return this.resource.note;
    }
    /*
     * STRING Values
     */
    get asString() {
        var _a, _b, _c;
        const tmp = {
            codeDisplay: (_a = this.codeObj) === null || _a === void 0 ? void 0 : _a.display,
            performerType: (_b = this.performerType) === null || _b === void 0 ? void 0 : _b.display,
            reasonCodes: joinArrayWithObjectToString(this.reasonCodes, 'text', '; '),
            orderDetail: joinArrayWithObjectToString(this.orderDetails, 'text', '; '),
            category: (_c = this.category) === null || _c === void 0 ? void 0 : _c.display,
            notes: joinArrayWithObjectToString(this.notes, 'text', '; '),
            full: '',
            short: '',
        };
        if (this.isReferral) {
            tmp.full = joinValuesToString([tmp.performerType, tmp.reasonCodes], ' • ');
            tmp.short = tmp.performerType;
        }
        else if (this.isOrder) {
            tmp.full = joinValuesToString([tmp.codeDisplay, tmp.orderDetail], ' • ');
            tmp.short = tmp.codeDisplay;
        }
        return tmp;
    }
}
export default ExtractorServiceRequest;
